/**
 * sendReceipt — ask the backend to deliver a sale receipt to the customer.
 *
 * The server sends over WhatsApp (Cloud API) and, if the number isn't reachable
 * there, falls back to an SMS carrying a public invoice link. This happens
 * entirely server-side, so the cashier gets a one-tap send with no pop-up or
 * navigation. (The old wa.me link opened WhatsApp; this replaces it.)
 */
import { http } from '@/services/httpClient';

export interface SendReceiptResult {
  ok: boolean;
  channel: 'whatsapp' | 'sms' | 'none';
  dryRun?: boolean;
  reason?: string;
  link: string;
}

export async function sendReceipt(invoiceId: string, phone?: string): Promise<SendReceiptResult> {
  try {
    // Always send a JSON body (even {}) so the Content-Type: application/json
    // header the client sets has a body to match — Fastify 400s otherwise.
    return await http<SendReceiptResult>(`/api/receipt/send/${invoiceId}`, {
      method: 'POST',
      body: phone ? { phone } : {},
    });
  } catch (e) {
    return {
      ok: false,
      channel: 'none',
      reason: e instanceof Error ? e.message : 'Could not reach the server',
      link: '',
    };
  }
}
